import React from 'react'
import { Grid } from '@the-platform-group/component-library/Layout'
import { Typography } from '@the-platform-group/component-library'

import { useCustomers } from './hooks/useCustomers'
import CustomerFilters from './components/CustomerFilters'
import CustomersTable from './components/Table/CustomersTable'
import { ListPaper } from 'components/Paper'

const CustomersComponent = () => {
  const {
    customers,
    pagination,
    isLoading,
    filters,
    sort,
    setPagination,
    handleSortChange,
    handleSortReset,
    handleCustomerTypeFilterChange,
    handleCustomerActiveStateFilterChange,
    handleCustomerNameSearch,
    handleCustomerEdit,
    handleCustomerFeatureToggle,
    handleCustomerArchive,
    handleCustomerUnarchive,
    handleCustomerSecurity,
    getModalComponents,
  } = useCustomers()
  return (
    <React.Fragment>
      <Typography variant="h4" component="h1">
        Customers
      </Typography>
      <Grid container direction="column" spacing={2}>
        <Grid item alignItems="center" container>
          <Grid item xs={12}>
            <CustomerFilters
              filters={filters}
              handleCustomerTypeFilterChange={handleCustomerTypeFilterChange}
              handleCustomerNameSearch={handleCustomerNameSearch}
              handleCustomerActiveStateFilterChange={handleCustomerActiveStateFilterChange}
            />
          </Grid>
        </Grid>

        <Grid item>
          <ListPaper>
            <CustomersTable
              isLoading={isLoading}
              customers={customers}
              pagination={pagination}
              setPagination={setPagination}
              sort={sort}
              handleSortChange={handleSortChange}
              handleSortReset={handleSortReset}
              handleCustomerEdit={handleCustomerEdit}
              handleCustomerFeatureToggle={handleCustomerFeatureToggle}
              handleCustomerArchive={handleCustomerArchive}
              handleCustomerUnarchive={handleCustomerUnarchive}
              handleCustomerSecurity={handleCustomerSecurity}
            />
          </ListPaper>
        </Grid>
      </Grid>

      {getModalComponents()}
    </React.Fragment>
  )
}

export default CustomersComponent
